module.exports = __webpack_public_path__ + "img/unsei-kichi.8bfb9d14.png";